import React from 'react'
import HomeNavbar from './HomeNavbar'
import Footer from './Footer'

function PrivacyPolicy() {
  return (
    <>
      <HomeNavbar />

      <div className="bg-white w-full py-20 text-center font-oswald mt-10">
        <div className="flex items-center justify-center">
          <p
            style={{ backgroundColor: "#F5A623" }}
            className="rounded-full py-2 px-6 font-bold text-bgBlue"
          >
            P&C
          </p>
        </div>

        <br />

        <h2 className="text-3xl font-bold text-gray-900">
          Privacy & <span className="text-secondary">Policy</span>
        </h2>

        <div className="lg:w-3/4 m-auto shadow-xl mt-10">
          <div className="text-bgBlue p-8 text-start">

            <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
            <p className="mb-4">Effective Date: 30 November 2025</p>

            {/* 1 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Introduction</h2>
              <p>
               This Privacy Policy applies to <strong>Adhyayi</strong> (“Platform”, “we”, “our”,
“us”), owned and operated by <strong>AKRYPT IT SOLUTIONS PRIVATE LIMITED</strong>, a company
incorporated under the Companies Act, 2013, India.

              </p>
              <p>
                This Policy explains how we collect, use, store, disclose, and protect user data when you
access or use our website and mobile application.

              </p>
              <p>By using the Platform, you agree to the terms of this Privacy Policy.
                </p>
            </section>

            {/* 2 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Nature of the Platform</h2>
              <p>Adhyayi is a <strong>skill-based educational learning platform</strong> that provides courses, quizzes, and
performance-based contests.
</p>
              <ul className="list-disc ml-6">
                <li>All outcomes depend on user knowledge, preparation, and performance</li>
                <li>The Platform <strong>does NOT involve gambling, betting, wagering, or games of chance</strong></li>
                <li>No outcome is based on luck or random factors</li>
                
              </ul>
            </section>

            {/* 3 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Information We Collect</h2>

              <p className="font-semibold mt-2">Personal Information</p>
              <ul className="list-disc ml-6">
                <li>Full name</li>
                <li>Mobile number</li>
                <li>Email address (optional)</li>
                <li>Login credentials</li>
                <li>Educational preferences</li>
              </ul>

              <p className="font-semibold mt-2">Phone Number Verification</p>
              <ul className="list-disc ml-6">
                <li>
We use your mobile number to send OTP (One-Time Password) via SMS or WhatsApp for login, account verification, and security purposes.</li>
                </ul>

              <p className="font-semibold mt-4">KYC & Identity Data</p>
              <ul className="list-disc ml-6">
                <li>Aadhaar / PAN / Government ID</li>
                <li>Uploaded documents</li>
                <li>Selfie (if required)</li>
              </ul>

              <p className="mt-2">
                Collected only for verification, fraud prevention, and withdrawals.
              </p>

              <p className="font-semibold mt-4">Financial Information</p>
              <ul className="list-disc ml-6">
                <li>Bank account details</li>
                <li>UPI ID</li>
              </ul>

              <p className="mt-2">
                We <strong>do NOT collect or store</strong> OTP, PIN, or passwords.
              </p>

              <p className="font-semibold mt-4">Usage & Device Information</p>
              <ul className="list-disc ml-6">
                <li>IP address</li>
                <li>Device, OS, browser</li>
                <li>App usage data (quiz attempts, scores, rankings)</li>
                <li>Login time, activity logs</li>
              </ul>

              <p className="font-semibold mt-4">Location Information</p>
              <ul className="list-disc ml-6">
                <li>State/region (via IP detection)</li>
                <li>Used for legal compliance only</li>
                <li>No precise GPS tracking without permission</li>
              </ul>
            </section>

            {/* 4 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>How We Use Data</h2>
              <p>We use data to:</p>
              <ul className="list-disc ml-6">
                <li> Provide and improve the Platform</li>
                <li>Conduct quizzes, contests, and courses</li>
                <li>Track performance, scores, and rankings</li>
                <li>Manage wallet, Credits, and withdrawals</li>
                <li>Verify identity (KYC)</li>
                <li>Detect fraud and misuse</li>
                <li>Comply with legal and regulatory requirements</li>
              </ul>
            </section>

            {/* 5 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Wallet & Reward Data</h2>
              <p>We maintain internal wallet records including:</p>
              <ul className="list-disc ml-6">
                <li>Contest Credits</li>
                <li>Referral Credits</li>
                <li>Quiz/Course Credits</li>
                <li>Recharge Credits</li>
              </ul>

               <p>These are used for:</p>
              <ul className="list-disc ml-6">
                <li>Contest settlement</li>
                <li>Reward calculation</li>
                <li>Withdrawal processing</li>
                <li>Fraud detection</li>
                <li>Minimum withdrawal thresholds</li>
                <li>User verification and KYC requirements</li>
                <li>Applicable taxes (GST, TDS if applicable)</li>
                <li>Internal compliance checks</li>
              </ul>

              <p className='mt-2'>Recharge Credits are maintained separately as <strong>non-withdrawable balances</strong>.</p>
            </section>

            {/* 6 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Virtual Credits & Rewards</h2>
              <ul className="list-disc ml-6">
                <li>Credits are <strong>virtual reward points</strong></li>
                <li>Credits do not represent real currency or stored value</li>
                <li>Credits have no guaranteed monetary return</li>
                <li>Credit value (e.g., 100 Credits = ₹1) may change at Platform discretion</li>
                <li>Wallet balances are internal records maintained by the Platform.</li>
              </ul>
            </section>

            {/* 7 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Payments & Third-Party Processing</h2>
              <ul className="list-disc ml-6">
                <li>Payments and withdrawals are handled via <strong>RBI-authorized payment gateways and banking partners</strong>.</li>
                <li>We do not store card details or sensitive payment credentials</li>
                <li>Third-party providers follow their own privacy policies</li>
            
              </ul>
            </section>

            {/* 8 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Data Sharing</h2>
              <p>We do not sell user data</p>
              <p>Data may be shared with:</p>
              <ul className="list-disc ml-6">
                <li>Legal authorities (if required by law)</li>
                <li>KYC verification providers</li>
                <li>Cloud hosting and analytics services</li>
                <li>Legal authorities (if required by law)</li>
              </ul>
              <p className="mt-2">All partners are required to maintain data confidentiality</p>
            </section>

            {/* 9 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Fraud Prevention & Monitoring</h2>
              <p>
                We may monitor:
              </p>
              <ul className="list-disc ml-6">
                <li>Device information</li>
                <li>IP address</li>
                <li>Usage behavior</li>
              </ul>
              <p className="mt-2">
                This is done to:
              </p>
              <ul className="list-disc ml-6">
                <li>Detect fraud</li>
                <li>Prevent misuse</li>
                <li>Ensure fair play</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Contest Access Policy</h2>
              <p>
                Access to Free, Paid, Promotional, or Special Contests is determined by the platform based on user activity, contest history, rewards earned, Fair Play status, and other eligibility criteria. Adhyayi may enable or restrict contest access for specific users to maintain platform fairness and sustainability.
              </p>
             
            </section>

            {/* 10 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Data Retention & Security</h2>
              <p className="mt-2">
                We retain data:
              </p>
              <ul className="list-disc ml-6">
                <li>While your account is active</li>
                <li>As required for legal and compliance purposes</li>
                <li>For dispute resolution and fraud prevention</li>
              </ul>
              <p className="mt-2">We implement reasonable administrative, technical, and organizational security measures to
protect user data from unauthorized access, misuse, loss, alteration, or disclosure</p>
              <p className="mt-2">
                However, no system is completely secure, and we cannot guarantee absolute security of data
              </p>
            </section>

            {/* 11 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>User Rights</h2>
                <p className="mb-2">You have the right to:</p>
              <ul className="list-disc ml-6">
                <li>Access your personal data</li>
                <li>Request correction of incorrect data</li>
                <li>Request deletion of your data (subject to legal obligations)</li>
                <li>Withdraw consent</li>
              </ul>
              <p className="mt-2">Requests can be made via email.</p>
            </section>

            {/* 12 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Children's Privacy</h2>
              <p>The Platform is intended for users aged <strong>16 years and above</strong></p>
              <p>Users below 18 should use the Platform under parental or guardian supervision.</p>
              <p>We do not knowingly collect data from children below the allowed age.</p>
            </section>

            {/* 13 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>International Data Transfers</h2>
              <p>Your data may be processed on servers located outside India.</p>
              <p>All transfers comply with applicable data protection laws.</p>
            </section>

            {/* 14 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Legal Compliance</h2>
              <p className="mb-2">This Policy complies with:</p>
              <ul className="list-disc ml-6">
                <li>Information Technology Act, 2000</li>
                <li>IT Rules 2011</li>
                <li> Digital Personal Data Protection Act, 2023</li>
                <li> RBI guidelines (for payment processing)</li>
              </ul>
            </section>

            {/* 15 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Changes to This Policy</h2>
              <p>We may update this Privacy Policy from time to time.</p>
              <p>Users will be notified of significant changes. Continued use implies acceptance.</p>
            </section>

            {/* 16 */}
            <section className="mb-6">
              <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Contact Information</h2>
              <p>For any questions or requests:</p>
              <p>
                Email:{" "}
                <a href="mailto:support@adhyayi.com" className="text-blue-500 underline">
                  support@adhyayi.com
                </a>
              </p>
            </section>

          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default PrivacyPolicy